module.exports = {
      id: "adventure-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#adventure",
      toString: function () {
        return this.url;
      }
    }